/*
NOTE:
This function is attach to Dexero form object himself attach to DCA (Dexero Core App) object and called in necessary form files.
Form #content click event binding and handling are both realized in this init function.
*/

export type IInitPasswordFields = IDCA.IGenericFunc;

export function _initPasswordFields(): void {
  $('#content').on('click', '.password-button', (event: JQuery.ClickEvent<HTMLElement>) => {
    // Get elements.
    const $passwordButton = $(event.currentTarget);
    const $passwordButtonIcon = $passwordButton.find('.password-button-icon');
    const $inputField = $passwordButton.parent('.input-group-btn').siblings('.form-control');

    // Get tooltip titles.
    const dataTitleShow = $passwordButton.data('title-show');
    const dataTitleHide = $passwordButton.data('title-hide');

    // Toggle input type, tooltip title and classes.
    if (!$passwordButton.hasClass('active')) {
      $inputField.attr('type', 'text');
      $passwordButton.attr('data-original-title', dataTitleHide);
    } else {
      $inputField.attr('type', 'password');
      $passwordButton.attr('data-original-title', dataTitleShow);
    }
    $passwordButtonIcon.toggleClass('fa-eye fa-eye-slash');
    $passwordButton.toggleClass('active');
    $passwordButton.tooltip('show');
  });
}
